import { BarChart3, Phone, ClipboardList, Tag, Gift, Video, LayoutTemplate, UserRound, CalendarClock, ArrowRight } from "lucide-react";
import { PILLARS, TASKS } from "../data/proposal";
import { SectionHead } from "./SectionHead";

const ICONS = { chart: BarChart3, phone: Phone, list: ClipboardList, tag: Tag, gift: Gift, video: Video, layout: LayoutTemplate };

const Visual = ({ t, onZoom }) => {
  if (t.img) {
    return (
      <button onClick={() => onZoom({ img: t.img, title: t.result })} className="h-24 w-16 shrink-0 overflow-hidden rounded-lg border border-[var(--line)]" data-testid="task-thumb">
        <img src={t.img} alt={t.result} className="h-full w-full object-cover object-top" />
      </button>
    );
  }
  const Icon = ICONS[t.icon];
  return <div className="grid h-16 w-16 shrink-0 place-items-center rounded-xl bg-[#47BBBC]/15 text-[var(--teal-d)]"><Icon size={26} /></div>;
};

const Row = ({ t, idx, onZoom }) => (
  <div data-testid={`task-row-${idx}`} className="grid gap-4 border-t border-[var(--line)] py-6 md:grid-cols-[1fr_auto_1.1fr_auto] md:items-center md:gap-6">
    <div className="flex items-center gap-4">
      <Visual t={t} onZoom={onZoom} />
      <div>
        <span className="result-tag">預期成果</span>
        <p className="mt-1 text-base font-bold text-[var(--ink)]">{t.result}</p>
      </div>
    </div>
    <ArrowRight className="hidden text-[var(--orange-2)] md:block" />
    <div>
      <span className="action-tag">需要的動作</span>
      <p className="mt-1 text-[var(--ink)]">{t.action}</p>
    </div>
    <div className="flex flex-wrap gap-2 md:flex-col md:items-end">
      <span className="owner-tag"><UserRound size={14} /> {t.owner}</span>
      <span className="inline-flex items-center gap-1 text-sm font-bold text-[var(--text)]"><CalendarClock size={14} /> {t.due}</span>
    </div>
  </div>
);

export const Tasks = ({ onZoom }) => (
  <section id="tasks" data-testid="tasks-section" className="mx-auto max-w-6xl px-5 py-20">
    <SectionHead no="05" title="配合清單" sub="每一項：預期成果 → 需要的動作 → 負責窗口 → 期限" />
    {PILLARS.map((p, gi) => (
      <div key={p.no} id={`group-${gi + 1}`} data-testid={`task-group-${gi + 1}`} className="mt-12 scroll-mt-6">
        <h3 className="mb-2 flex items-center gap-3 text-xl font-black text-[var(--ink)]">
          <span className="text-3xl text-[var(--orange)]">{p.no}</span>{p.title}
        </h3>
        {TASKS.map((t, i) => t.group === p.no && <Row key={i} t={t} idx={i} onZoom={onZoom} />)}
      </div>
    ))}
  </section>
);
